import {Route, Routes} from "react-router-dom"
import {ErrorPage, NotFoundPage} from "@indebted/components/Error"
import {Suspense} from "react"
import {LoadingPage} from "@indebted/components/Loading"
import {ErrorBoundary} from "react-error-boundary"

import {PaymentMethodPage} from "./PaymentMethodSelection"
import {Status} from "./Status"
import {ManagePaymentArrangementPage} from "./ManagePaymentArrangement"
import {InitiatedOrSubmittedPage} from "./StatusPage/InitiatedOrSubmitted"
import {FailedPage} from "./StatusPage/Failed"
import {AutomaticallyCancelledPage} from "./StatusPage/AutomaticallyCancelled"
import {UpdatePaymentArrangement} from "./UpdatePaymentArrangement"
import {CancelledByCustomerPage} from "./StatusPage/CancelledByCustomer"
import {InstalmentStatus} from "./InstalmentStatus"
import {CompletedPage} from "./StatusPage/Completed"
import {SliderPage} from "./Slider"
import {CancelledByAgentPage} from "./StatusPage/CancelledByAgent"
import {EFTAPage} from "./EFTA"
import {PaymentInFullPage} from "./PaymentMethodSelection/PaymentInFull"

function PaymentArrangementRouter() {
	return (
		<Suspense fallback={<LoadingPage />}>
			<ErrorBoundary fallbackRender={(err) => <ErrorPage error={err} />}>
				<Routes>
					<Route path=":id">
						<Route element={<SliderPage />} path="setup" />
						<Route element={<PaymentMethodPage />} path="payment-method" />
						<Route element={<EFTAPage />} path="efta" />
						<Route element={<Status />} path="status" />
						<Route element={<InitiatedOrSubmittedPage />} path="status/submitted" />
						<Route element={<InitiatedOrSubmittedPage />} path="status/initiated" />
						<Route element={<FailedPage />} path="status/failed" />
						<Route element={<AutomaticallyCancelledPage />} path="status/automatically-cancelled" />
						<Route element={<CancelledByCustomerPage />} path="status/cancelled-by-customer" />
						<Route element={<CancelledByAgentPage />} path="status/cancelled-by-agent" />
						<Route element={<CompletedPage />} path="status/completed" />
						<Route element={<ManagePaymentArrangementPage />} path="manage" />
						<Route element={<UpdatePaymentArrangement />} path="update" />
						<Route element={<InstalmentStatus />} path="instalment-status" />
						<Route element={<PaymentInFullPage />} path="payment-in-full" />
						<Route element={<NotFoundPage />} index />
					</Route>
					<Route element={<NotFoundPage />} path="*" />
				</Routes>
			</ErrorBoundary>
		</Suspense>
	)
}

export {PaymentArrangementRouter}
